module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-06.1948bbeb.jpg";